<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/financial/suppliers/new')">
          <i class="plus icon"></i> Novo Fornecedor
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="suppliers-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="suppliers-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="navToSupplierForm" />

  </div>

</template>

<script>
  
  import SupplierService from "@/services/supplier-service"
  import { gridPage, onlyFinancial } from "@/mixins"

  export default {    

    name: "SuppliersPage",

    mixins: [gridPage, onlyFinancial],

    data() {
      return {        
        title: "Fornecedores",
        service: new SupplierService(),
        attributes: ["id", "shortName", "cgc", "city", "state", "email", "phone"],
        fields: [          
          { prop: "shortName", label: "Nome" },
          { prop: "cgc", label: "CNPJ / CPF", render: (supplier) => this.$formatCgc(supplier.cgc) },
          { prop: "email", label: "E-mail" },                    
          { prop: "phone", label: "Telefone" },                    
          { prop: "city", label: "Município", render: this.renderCity },
        ],
      }
    },

    methods: {

      navToSupplierForm(data) {
        this.$router.push("/financial/suppliers/" + data.row.id)
      },

      renderCity(supplier) {

        if (!supplier.city)
          return ""

        return supplier.city.trim() + " / " + supplier.state
      }
    },
  }

</script>
